import script from "./TasksFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./TasksFilter.vue?vue&type=script&setup=true&lang=js"

import "./TasksFilter.vue?vue&type=style&index=0&id=4d8bf740&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d8bf740"]])

export default __exports__